import { styled } from '@/src/stitches.config'
import { IRedemptionOptions } from '@/src/common/queries/FetchReceivedGiftDetails'
import { ModalContent } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import NewRedemptionModalContent from '@/src/modules/account/received/GiftWalletRedemptionModalContent'
import DispatchModal from '@/src/common/components/elements/Modals/DispatchModal'
import {
    CARD_LINK,
    EDIT_SAVED_CARDS,
    UNENROLL_CARD_FROM_LINK,
} from '@/src/modules/pg-plus/constants'
import { useEffect } from 'react'
import { scrollToTop } from '@/src/common/utilities/scrollToTop'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { DISPATCH_HIDE_MODAL } from '@/src/common/reducers/constants'
import VirtualVisaRedemptionOptions from '@/src/modules/account/received/redemption-methods/content/VirtualVisaRedemptionOptions'
import BrandedRedemptionButtons from '@/src/modules/account/received/redemption-methods/content/BrandedRedemptionButtons'

const ComponentWrapper = styled('div', {
    textAlign: 'center',
    '.headline-eyebrow': {
        display: 'flex',
        fd: 'column',
        fontSize: '1rem',
    },
    '.white-box': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '.em-dash': {
        fontSize: '1.5rem',
    },
    '& p': {
        lineHeight: '1.75rem',
    },
    '& button': {
        width: 300,
        fontSize: '1rem',
        mb: 10,
    },
})

function determineModalData(modalName: string, showModal: boolean) {
    let modalType: 'iframe' | undefined = undefined
    let determineIfShowModal: boolean = showModal

    if (modalName === EDIT_SAVED_CARDS) {
        modalType = 'iframe'
    }

    if (modalName === CARD_LINK || modalName === UNENROLL_CARD_FROM_LINK) {
        determineIfShowModal = false
    }

    return {
        modalType: modalType,
        determineIfShowModal: determineIfShowModal,
    }
}

interface IOptions {
    redemptionOptions: IRedemptionOptions | undefined
    plastic_exchange_eligible: boolean
    isVirtualVisa: boolean
    isEgift: boolean
    hasBeenCardLinked: boolean
    refetchGift: Function
}

const RedemptionOptions = ({
    redemptionOptions,
    plastic_exchange_eligible,
    isVirtualVisa,
    isEgift,
    hasBeenCardLinked,
    refetchGift,
}: IOptions) => {
    const { dispatch, giftState } = usePGPlusStepAndModalContext()
    const { showModal, stepName, modalName } = giftState
    const showVirtualVisaOptions: boolean =
        isVirtualVisa && plastic_exchange_eligible

    const { modalType, determineIfShowModal } = determineModalData(
        modalName,
        showModal
    )

    useEffect(() => {
        scrollToTop('__next')
    }, [stepName])

    return (
        <ComponentWrapper>
            <DispatchModal
                showModal={
                    showVirtualVisaOptions ? showModal : determineIfShowModal
                }
                hideModalAction={() => dispatch({ type: DISPATCH_HIDE_MODAL })}
                testId={'redemption-modal'}
                width={'small'}
                height={modalType === 'iframe' ? '550px' : undefined}
                variant={modalType}
            >
                <ModalContent>
                    <NewRedemptionModalContent
                        hasBeenCardLinked={hasBeenCardLinked}
                        refetchGift={refetchGift}
                    />
                </ModalContent>
            </DispatchModal>
            <ComponentWrapper>
                {showVirtualVisaOptions ? (
                    <VirtualVisaRedemptionOptions />
                ) : (
                    <BrandedRedemptionButtons
                        redemptionOptions={redemptionOptions}
                        isEgift={isEgift}
                    />
                )}
            </ComponentWrapper>
        </ComponentWrapper>
    )
}

export default RedemptionOptions
